import { render, staticRenderFns } from "./FinancialTips.vue?vue&type=template&id=d64308c6&scoped=true"
import script from "./FinancialTips.vue?vue&type=script&lang=js"
export * from "./FinancialTips.vue?vue&type=script&lang=js"
import style0 from "./FinancialTips.vue?vue&type=style&index=0&id=d64308c6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d64308c6",
  null
  
)

export default component.exports